import React from 'react';
import { View, StyleSheet } from 'react-native';
import { MB_SVG_Smile, MB_SVG_HourglassEnd, MB_SVG_Clock, MB_SVG_Check, MB_SVG_Trash, MB_SVG_ExclamationCircle } from '@/components/general/svg-components';
import { isMobile } from '@/utils/general/device-info';
import { mbApplyTransparency } from '@/utils/general/style-utils';

const baseStyles = StyleSheet.create({
  vectorIconContainer: {
    width: isMobile ? 72 : 108,
    height: isMobile ? 72 : 108,
    backgroundColor: '#361E32',
    borderRadius: 300,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

const styles = StyleSheet.create({
  redIconWrapper: {
    borderRadius: 300,
    width: isMobile ? 72 : 108,
    height: isMobile ? 72 : 108,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: mbApplyTransparency('#FF3B3B', 0.1),
  },
  greenIconWrapper: StyleSheet.flatten([
    baseStyles.vectorIconContainer,
    {
      backgroundColor: mbApplyTransparency('#0CE515', 0.12),
    },
  ]),
  orangeIconWrapper: StyleSheet.flatten([
    baseStyles.vectorIconContainer,
    {
      backgroundColor: mbApplyTransparency('#FE6F00', 0.12),
    },
  ]),
});

const MB_PopUpTemplateComponents = {
  components: {
    exclamationCircle: (
      <View style={baseStyles.vectorIconContainer}>
        <MB_SVG_ExclamationCircle size={isMobile ? 35 : 56} color={'#FF3B3B'} />
      </View>
    ),
    smilyFace: (
      <View style={styles.greenIconWrapper}>
        <MB_SVG_Smile size={isMobile ? 41 : 63} color={'#0CE515'} />
      </View>
    ),
    redClock: (
      <View style={styles.redIconWrapper}>
        <MB_SVG_Clock size={isMobile ? 41 : 63} color={'#FF3B3B'} />
      </View>
    ),
    checkmark: (
      <View style={styles.greenIconWrapper}>
        <MB_SVG_Check size={isMobile ? 41 : 63} color={'#0CE515'} />
      </View>
    ),
    trashcan: (
      <View style={styles.redIconWrapper}>
        <MB_SVG_Trash size={isMobile ? 31 : 52} color={'#FF3B3B'} />
      </View>
    ),
    hourglass: (
      <View style={styles.orangeIconWrapper}>
        <MB_SVG_HourglassEnd size={isMobile ? 31 : 52} color={'#FE6F00'} />
      </View>
    ),
  },
};

export { MB_PopUpTemplateComponents };
